/* eslint-disable no-restricted-globals */
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { useConfiguraionContext } from '../../../context/ProviderPage/Configuration';
import { IConfigurationoDTO } from '../../../types/Configuration';
import { Option } from '../../../types/Option';
import {
  formatInputNumber,
  formatInputNumberWithoutZero,
} from '../../../utils/formatInputNumber';
import { CustomSwitch } from '../../CustomSwitch';
import {
  IModal,
  ModalConfiguration,
} from '../InfoConfiguration/ModalConfiguration';
import {
  ColumnItens,
  ContainerItemMediumModal,
} from '../InfoConfiguration/ModalConfiguration/styles';

interface IModifyValue {
  value: boolean;
  setValue: Dispatch<SetStateAction<boolean>>;
}

interface IEditOneAppConfiguration extends Option {
  titleModal: string;
}

export const EditOneAppConfiguration = ({
  titleModal,
  option,
}: IEditOneAppConfiguration) => {
  const {
    editOneConfiguration,
    setEditOneConfiguration,
    handleEditOneAppConfiguration,
    selectedConfiguration,
  } = useConfiguraionContext();

  const [DFDISTRIBUIR, setDFDISTRIBUIR] = useState(false);
  const [DFREGUAFRENTE, setDFREGUAFRENTE] = useState(false);
  const [DFREGUAATRAS, setDFREGUAATRAS] = useState(false);
  const [DFTERMOMENTRO, setDFTERMOMENTRO] = useState(false);
  const [DFLIBERARCOLETA, setDFLIBERARCOLETA] = useState(false);
  const [DFEXAMESENSORIAL, setDFEXAMESENSORIAL] = useState(false);
  const [DFEXAMEALIZAROL, setDFEXAMEALIZAROL] = useState(false);
  const [DFPASSOUNOALIZAROL, setDFPASSOUNOALIZAROL] = useState(false);
  const [DFFOTOSDEAMOSTRA, setDFFOTOSDEAMOSTRA] = useState(false);
  const [DFFOTOSDATEMPERATURA, setDFFOTOSDATEMPERATURA] = useState(false);
  const [DFAMOSTRA, setDFAMOSTRA] = useState(false);
  const [DFLACRE, setDFLACRE] = useState(false);
  const [DFATIVARPERCENTUALDELITRAGEM, setDFATIVARPERCENTUALDELITRAGEM] =
    useState(false);
  const [DFDIASDEVALIDACAO, setDFDIASDEVALIDACAO] = useState<string>('10');
  const [DFPORCENTAGEMDETOLERANCIA, setDFPORCENTAGEMDETOLERANCIA] =
    useState<string>('0');

  useEffect(() => {
    if (!selectedConfiguration) return;
    setDFDISTRIBUIR(selectedConfiguration.DFDISTRIBUIR === 'S');
    setDFREGUAFRENTE(selectedConfiguration.DFREGUAFRENTE === 'S');
    setDFREGUAATRAS(selectedConfiguration.DFREGUAATRAS === 'S');
    setDFTERMOMENTRO(selectedConfiguration.DFTERMOMENTRO === 'S');
    setDFLIBERARCOLETA(selectedConfiguration.DFLIBERARCOLETA === 'S');
    setDFEXAMESENSORIAL(selectedConfiguration.DFEXAMESENSORIAL === 'S');
    setDFEXAMEALIZAROL(selectedConfiguration.DFEXAMEALIZAROL === 'S');
    setDFPASSOUNOALIZAROL(selectedConfiguration.DFPASSOUNOALIZAROL === 'S');
    setDFFOTOSDEAMOSTRA(selectedConfiguration.DFFOTOSDEAMOSTRA === 'S');
    setDFFOTOSDATEMPERATURA(selectedConfiguration.DFFOTOSDATEMPERATURA === 'S');
    setDFAMOSTRA(selectedConfiguration.DFAMOSTRA === 'S');
    setDFLACRE(selectedConfiguration.DFLACRE === 'S');
    setDFATIVARPERCENTUALDELITRAGEM(
      selectedConfiguration.DFATIVARPERCENTUALDELITRAGEM === 'S',
    );
    setDFDIASDEVALIDACAO(
      String(selectedConfiguration.DFDIASDEVALIDACAO ?? '10'),
    );
    setDFPORCENTAGEMDETOLERANCIA(
      String(selectedConfiguration.DFPORCENTAGEMDETOLERANCIA ?? '0'),
    );
  }, [selectedConfiguration]);

  const config: IConfigurationoDTO = {
    DFDISTRIBUIR: DFDISTRIBUIR ? 'S' : 'N',
    // DFQUALIDADE: DFQUALIDADE ? 'S' : 'N',
    DFQUALIDADE: 'S',
    DFREGUAFRENTE: DFREGUAFRENTE ? 'S' : 'N',
    DFREGUAATRAS: DFREGUAATRAS ? 'S' : 'N',
    DFTERMOMENTRO: DFTERMOMENTRO ? 'S' : 'N',
    DFLIBERARCOLETA: DFLIBERARCOLETA ? 'S' : 'N',
    DFEXAMESENSORIAL: DFEXAMESENSORIAL ? 'S' : 'N',
    DFEXAMEALIZAROL: DFEXAMEALIZAROL ? 'S' : 'N',
    DFPASSOUNOALIZAROL: DFPASSOUNOALIZAROL ? 'S' : 'N',
    // DFAMOSTRADEQUALIDE: DFAMOSTRADEQUALIDE ? 'S' : 'N',
    DFAMOSTRADEQUALIDE: 'S',
    DFFOTOSDEAMOSTRA: DFFOTOSDEAMOSTRA ? 'S' : 'N',
    DFFOTOSDATEMPERATURA: DFFOTOSDATEMPERATURA ? 'S' : 'N',
    DFAMOSTRA: DFAMOSTRA ? 'S' : 'N',
    DFLACRE: DFLACRE ? 'S' : 'N',
    DFDIASDEVALIDACAO,
    DFATIVARPERCENTUALDELITRAGEM: DFATIVARPERCENTUALDELITRAGEM ? 'S' : 'N',
    DFPORCENTAGEMDETOLERANCIA,
  };

  const modifyValue = ({ setValue, value }: IModifyValue) => {
    setValue(!value);
  };

  const handleIncrement = () => {
    setDFDIASDEVALIDACAO(prev => (parseInt(prev, 10) + 1).toString());
  };

  const handleDecrement = () => {
    setDFDIASDEVALIDACAO(prev => {
      const newValue = parseInt(prev, 10) - 1;
      return newValue >= 0 ? newValue.toString() : prev;
    });
  };

  const handleIncrementTolerance = () => {
    setDFPORCENTAGEMDETOLERANCIA(prev => {
      const newValue = parseInt(prev, 10) + 1;
      return newValue <= 100 ? newValue.toString() : prev;
    });
  };

  const handleDecrementTolerance = () => {
    setDFPORCENTAGEMDETOLERANCIA(prev => {
      const newValue = parseInt(prev, 10) - 1;
      return newValue >= 0 ? newValue.toString() : prev;
    });
  };

  useEffect(() => {
    if (isNaN(Number(DFDIASDEVALIDACAO)) || DFDIASDEVALIDACAO === '') {
      setDFDIASDEVALIDACAO('10');
    } else if (DFDIASDEVALIDACAO === '0') {
      setDFDIASDEVALIDACAO('1');
    }
  }, [DFDIASDEVALIDACAO]);

  useEffect(() => {
    if (
      isNaN(Number(DFPORCENTAGEMDETOLERANCIA)) ||
      DFPORCENTAGEMDETOLERANCIA === ''
    ) {
      setDFPORCENTAGEMDETOLERANCIA('0');
    } else if (parseInt(DFPORCENTAGEMDETOLERANCIA, 10) < 0) {
      setDFPORCENTAGEMDETOLERANCIA('0');
    } else if (parseInt(DFPORCENTAGEMDETOLERANCIA, 10) > 100) {
      setDFPORCENTAGEMDETOLERANCIA('100');
    }
  }, [DFPORCENTAGEMDETOLERANCIA]);

  return (
    <ModalConfiguration
      option={option}
      titleModal={titleModal}
      closeModal={() => setEditOneConfiguration(false)}
      isOpen={editOneConfiguration}
      medium={true}
    >
      <ColumnItens>
        <ContainerItemMediumModal>
          <span>Forçar Medição da régua da frontal: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFREGUAFRENTE,
                setValue: setDFREGUAFRENTE,
              })
            }
            isOpen={DFREGUAFRENTE}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar Medição da régua trazeira: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFREGUAATRAS,
                setValue: setDFREGUAATRAS,
              })
            }
            isOpen={DFREGUAATRAS}
          />
        </ContainerItemMediumModal>
        {/* <ContainerItemMediumModal>
          <span>Forçar envio de imagem de qualidade: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFQUALIDADE,
                setValue: setDFQUALIDADE,
              })
            }
            isOpen={DFQUALIDADE}
          />
        </ContainerItemMediumModal> */}
        <ContainerItemMediumModal>
          <span>Forçar distribuição do leite: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFDISTRIBUIR,
                setValue: setDFDISTRIBUIR,
              })
            }
            isOpen={DFDISTRIBUIR}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar contraprova de tempertura: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFTERMOMENTRO,
                setValue: setDFTERMOMENTRO,
              })
            }
            isOpen={DFTERMOMENTRO}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar liberação da coleta: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFLIBERARCOLETA,
                setValue: setDFLIBERARCOLETA,
              })
            }
            isOpen={DFLIBERARCOLETA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar envio de exame sensorial: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFEXAMESENSORIAL,
                setValue: setDFEXAMESENSORIAL,
              })
            }
            isOpen={DFEXAMESENSORIAL}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar envio de exame alizarol: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFEXAMEALIZAROL,
                setValue: setDFEXAMEALIZAROL,
              })
            }
            isOpen={DFEXAMEALIZAROL}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar envio de passou no alizarol: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFPASSOUNOALIZAROL,
                setValue: setDFPASSOUNOALIZAROL,
              })
            }
            isOpen={DFPASSOUNOALIZAROL}
          />
        </ContainerItemMediumModal>
        {/* <ContainerItemMediumModal>
          <span>Forçar envio de amostra de qualidade: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFAMOSTRADEQUALIDE,
                setValue: setDFAMOSTRADEQUALIDE,
              })
            }
            isOpen={DFAMOSTRADEQUALIDE}
          />
        </ContainerItemMediumModal> */}
        <ContainerItemMediumModal>
          <span>Forçar envio de fotos da amostra: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFFOTOSDEAMOSTRA,
                setValue: setDFFOTOSDEAMOSTRA,
              })
            }
            isOpen={DFFOTOSDEAMOSTRA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar envio de fotos da temeperatura: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFFOTOSDATEMPERATURA,
                setValue: setDFFOTOSDATEMPERATURA,
              })
            }
            isOpen={DFFOTOSDATEMPERATURA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar envio da amostra: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFAMOSTRA,
                setValue: setDFAMOSTRA,
              })
            }
            isOpen={DFAMOSTRA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar envio do lacre: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFLACRE,
                setValue: setDFLACRE,
              })
            }
            isOpen={DFLACRE}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Forçar percentual de litragem: </span>
          <CustomSwitch
            action={() =>
              modifyValue({
                value: DFATIVARPERCENTUALDELITRAGEM,
                setValue: setDFATIVARPERCENTUALDELITRAGEM,
              })
            }
            isOpen={DFATIVARPERCENTUALDELITRAGEM}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Dias para validação do percentual</span>

          <div className="input-container">
            <button
              className="decrement-button"
              onClick={handleDecrement}
              disabled={DFDIASDEVALIDACAO === '1'}
            >
              -
            </button>
            <input
              className="days-to-validation-input"
              value={DFDIASDEVALIDACAO}
              onChange={text =>
                setDFDIASDEVALIDACAO(formatInputNumber(text.target.value))
              }
            />
            <button className="increment-button" onClick={handleIncrement}>
              +
            </button>
          </div>
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Percentual de Tolerância(%)</span>

          <div className="input-container">
            <button
              className="decrement-button"
              onClick={handleDecrementTolerance}
              disabled={DFPORCENTAGEMDETOLERANCIA === '0'}
            >
              -
            </button>
            <input
              className="days-to-validation-input"
              value={DFPORCENTAGEMDETOLERANCIA}
              onChange={text =>
                setDFPORCENTAGEMDETOLERANCIA(
                  formatInputNumber(text.target.value),
                )
              }
            />
            <button
              className="increment-button"
              onClick={handleIncrementTolerance}
              disabled={DFPORCENTAGEMDETOLERANCIA === '100'}
            >
              +
            </button>
          </div>
        </ContainerItemMediumModal>
        <button
          className="btn-action-button"
          onClick={() => handleEditOneAppConfiguration(config)}
        >
          Salvar
        </button>
      </ColumnItens>
    </ModalConfiguration>
  );
};
